import { Inject } from '@odinjs/odin';

import { Endpoint, FOUNDATION_ROUTES, ToastServiceProviderAccreditation } from '@philips-emr/hpms-provider-accreditation-commons';
import TermsService from '@philips-emr/hpms-provider-accreditation-commons/lib/services/terms-service';
import { HpmsTextHtmlAPI } from '@philips-emr/hpms-provider-accreditation-components';
import { ToastNotificationAPI } from '@philips-emr/tws-components';
import Controller, { OnAfterFetch, OnCancel, OnSubmit } from '@philips-emr/tws-core/lib/client';
import { FetchEvent, SubmitEvent } from '@philips-emr/tws-core/lib/component/types';
import { AuthenticationService, HttpService, MessageService, ModalService } from '@philips-emr/tws-core/lib/services';

import { AssingTermAliases as Aliases, FragmentNames } from '../codegen';

import BaseController from './BaseController';

interface Term {
  dsTerm: string,
  nrSequence: number,
}

@Controller({ fragment: FragmentNames.ASSING_TERM })
export default class AssingTermControler extends BaseController {

  @Inject(Aliases.TEXT_TERM)
  private textTerm: HpmsTextHtmlAPI;
  @Inject(Aliases.TOAST_NOTIFICATION)
  private toast: ToastNotificationAPI;

  @OnAfterFetch(Aliases.FETCH_TERM)
  onMountTermoTexto(event: FetchEvent): void {
    const { dsTerm } = event.data as Term;
    this.textTerm.setData(dsTerm);
  }

  @OnSubmit(Aliases.FORM_TERM)
  onSubmitTerm(event: SubmitEvent): void {
    const { record } = event;
    if (!record || !record.checked) {
      this.toast.setVisible(true);
      this.scrollDownPanelTerm();
      return;
    }

    HttpService.post(Endpoint.POST.TERMS, {}, { body: record }).then(() => {
      ModalService.close('term-modal');
      TermsService.checkTerms();
    }).catch(() => ToastServiceProviderAccreditation.error(MessageService.translate('pa.error-process-request')));
  }

  @OnCancel(Aliases.FORM_TERM)
  onclose(): void {
    AuthenticationService.logout().then(() => {
      this.historyService.push(FOUNDATION_ROUTES.LOGIN);
    }).catch(() => ToastServiceProviderAccreditation.error(MessageService.translate('pa.error-process-request')));
  }

  scrollDownPanelTerm(): void {
    const termPanel = document.querySelector<HTMLDivElement>('.c-modal__content--with-stack-manager');
    if (termPanel) {
      const { scrollHeight } = termPanel;
      termPanel.scrollTo({ top: scrollHeight, behavior: 'smooth' });
    }
  }
}
